module.exports = __webpack_public_path__ + "img/background32.7f17a51e.jpg";